import Glide from '@glidejs/glide';
import { ArrowControls, ArrowDisabler, ArrowResizer, CanSlide } from '../utils/_glide-plugins';
import ModalBox from '../utils/_modal-box.js';

export default class VideoSliderClass {

    constructor() {

        const SELECTOR = '.mtt-video-loop .glide';
        const ELEMENT = document.querySelector(SELECTOR);

        if (ELEMENT) {

            new Glide(ELEMENT, {
                type: 'slider',
                startAt: 0,
                perView: 2,
                gap: 32,
                animationDuration: 700,
                keyboard: false,
                bound: true,
                rewind: false,
                arrowClasses: {
                    'back': 'slider-arrow--left',
                    'next': 'slider-arrow--right',
                    'disabled': 'slider-arrow--disabled'
                },
                breakpoints: {
                    750: {
                        perView: 1
                    }
                }
            }).mount({ ArrowControls, ArrowDisabler, ArrowResizer, CanSlide });

            new ModalBox('.open-video-modal');

        }
    }
}